<script>
    const svg = '<svg viewBox="-1 -1 2 2"><circle r="1" /></svg>';
</script>

{@html svg}
